import { Button } from '@opendoor/bricks-next';

interface NearMeButtonProps {
  city?: string | null;
  count?: number | null;
}

const formatCityName = (slug: string): string => {
  return slug
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const CityNearMeButton: React.FC<NearMeButtonProps> = ({ city, count }) => {
  if (!city || !count) {
    return (
      <Button
        analyticsName="zero-homes-disabled-placeholder"
        size="medium"
        variant="secondary"
        label="No homes near you"
        disabled
      />
    );
  }

  return (
    <Button
      analyticsName="count-homes-near-you"
      size="medium"
      href={`/homes/${city}`}
      variant="primary"
      label={`${count} ${count === 1 ? 'home' : 'homes'} near you in ${formatCityName(city)}`}
    ></Button>
  );
};
